/**
 * D-3: a project is DIRECTLY driven when crew are assigned to the project
 * itself (project-anchored blocks — the assignments endpoint's `via_tasks`
 * entries are the Crew card's task-crew rollup, not direct blocks), or when it
 * has no live tasks at all (nothing else can ever move its status). Everything
 * else is task-driven: the task rollup steers the project status.
 *
 * Mirrors the server's `projectIsDirectlyDriven` + rollup semantics. Returns
 * undefined while the inputs are still loading so callers choose their own
 * safe default (ProjectDetail treats unknown as task-driven; the crew screen
 * keeps its buttons until task-driven is KNOWN, protecting the crew hot path).
 */
export function isDirectlyDriven(
  assignments: { assignments: Array<{ via_tasks?: boolean }> } | undefined,
  tasks: { data: Array<{ status: string }> } | undefined,
): boolean | undefined {
  if (assignments?.assignments.some((a) => !a.via_tasks)) return true;
  if (tasks != null && tasks.data.filter((t) => t.status !== 'cancelled').length === 0) return true;
  if (assignments == null || tasks == null) return undefined;
  return false;
}
